import { create } from "zustand";
import ApiService from "Helpers/ApiService";
import type PlantingModel from "Models/Planting";

interface PlantingStoreState {
    plantings: PlantingModel[];
    getPlantings: (ids: string[]) => Promise<PlantingModel[]>;
    createPlanting: (planting: PlantingModel) => Promise<PlantingModel>;
    updatePlanting: (planting: PlantingModel) => Promise<PlantingModel>;
    deletePlanting: (id: string) => Promise<void>;
}

export const usePlantingStore = create<PlantingStoreState>((set) => ({
    plantings: [],
    getPlantings: async (ids) => {
        const plantings = await ApiService.getPlantings(ids);
        if (!Array.isArray(plantings)) {
            throw new Error("Unable to load plantings");
        }
        set({ plantings });
        return plantings;
    },
    createPlanting: async (planting) => {
        const createdPlanting = await ApiService.createPlanting(JSON.stringify(planting));
        set((state) => ({
            plantings: [...state.plantings.filter((item) => item._id !== planting._id), planting],
        }));
        return createdPlanting;
    },
    updatePlanting: async (planting) => {
        const updatedPlanting = await ApiService.updatePlanting(JSON.stringify(planting));
        set((state) => ({
            plantings: state.plantings.map((item) => item._id === planting._id ? planting : item),
        }));
        return updatedPlanting;
    },
    deletePlanting: async (id) => {
        await ApiService.deletePlanting(id);
        set((state) => ({
            plantings: state.plantings.filter((planting) => planting._id !== id),
        }));
    },
}));
